/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

const normalizeDomain = (domain) => (domain || '').toLowerCase().trim();

// Components
import AuthContainer from './AuthContainer.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';

const __vue_script__ = {
    name: 'LoginWithSSO',

    components: {
        AuthContainer,
        BaseInput
    },

    props: {
        initialDomain: {
            type: String,
            default: null
        }
    },

    data() {
        const domain = this.initialDomain || this.$services.sso.getLastDomain();
        return {
            ssoDomain: domain,
            bookmarkLink: domain ? this.buildBookmarkLink(domain) : '',
            showError: false,
            submitting: false
        };
    },

    watch: {
        ssoDomain(newDomain) {
            this.$refs.form.setErrors({});
            this.bookmarkLink = this.buildBookmarkLink(newDomain);
        }
    },

    methods: {
        /**
         * Submit the request for a new password
         */
        async submit() {
            try {
                this.reset();
                console.info('[LoginWithSSO] Submitting...');
                this.submitting = true;
                const domain = normalizeDomain(this.ssoDomain);
                const ssoExists = await this.$services.sso.domainExists(domain);
                if (!ssoExists) {
                    this.$refs.form.setErrors({
                        ssoDomain: this.$i18n.t('login.errors.saml_org_not_found').toString()
                    });
                } else {
                    this.$services.sso.storeDomain(this.ssoDomain);
                    this.$services.router.redirectToSSOUrl(domain);
                }
            } catch (error) {
                const err = get(error, 'response.data.error', {});
                console.info('[LoginWithSSO] An error occurred:', err, error);
                this.showError = true;
            } finally {
                this.submitting = false;
            }
        },

        /**
         * Resets all the errors and component's default
         */
        reset() {
            this.showError = null;
        },

        /**
         * Builds the bookmark link using the provided SSO domain.
         */
        buildBookmarkLink(domain) {
            const path = this.$const.ROUTE_SSO_DIRECT_ACCESS.replace(':domain', normalizeDomain(domain));
            return this.$services.router.getHomeUrl(path, '', 'https');
        },

        /**
         * Navigates to the account login page
         */
        toLogin() {
            this.$services.sso.forgetLastDomain();
            this.$router.push({ path: this.$const.ROUTE_LOGIN });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',[_c('validation-observer',{ref:"form",attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var valid = ref.valid;
return [_c('form',{staticClass:"sso-login",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.submit)}}},[_c('h2',[_vm._v(_vm._s(_vm.$t('login.forms.fieldsets.login_with_sso')))]),(_vm.showError)?_c('div',{staticClass:"alert alert-error"},[_c('p',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.$t('general.try_later')))])]):_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"ssoDomain"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"sso-domain",class:{'valid': valid},attrs:{"placeholder":_vm.$t('login.forms.sso_domain'),"name":"ssoDomain","errors":errors},model:{value:(_vm.ssoDomain),callback:function ($$v) {_vm.ssoDomain=$$v},expression:"ssoDomain"}})]}}],null,true)}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(valid),expression:"valid"}],staticClass:"bookmark-text"},[_vm._v(_vm._s(_vm.$t('login.forms.tips.bookmark_text', [_vm.bookmarkLink])))]),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"action"},[_c('button',{staticClass:"btn btn-login",attrs:{"disabled":_vm.submitting}},[_vm._v(_vm._s(_vm.$t('general.continue')))])])]),_c('div',{staticClass:"actions links"},[_c('div',{staticClass:"action"},[_c('a',{staticClass:"has-action",on:{"click":_vm.toLogin}},[_vm._v(_vm._s(_vm.$t('login.links.return_to_login')))])])])],1)]}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LoginWithSSO.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__